<script>
    import moment from 'moment';
    import { onMount } from 'svelte';

    export let standard;
    export let holiday;
   
    let openingTimes = [];
    let objectTimes = [];

    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];


    onMount(async () => {

        console.log( holiday );

        openingTimes = standard.split(',').map(dayToken => {
        let chunks = dayToken.split(/:/);
        return {
            day: +chunks[0],
            openHour: ("0" + chunks[1]).slice(-2),
            openMins: (chunks[2] + "0").slice(-2),
            closeHour: ("0" + chunks[3]).slice(-2),
            closeMins: (chunks[4] + "0").slice(-2),
        }
        });

       

 
        // -- Set Some Vars Up
        let dayCount = 0;
        const today = moment();
        const from_date = moment().startOf('week');
        const to_date = moment().endOf('week');

       
        
        // -- Start Off With Sunday
        let x = isHolidayDate( from_date, dayCount );
        if( !x ) {
            let data = openingTimes[0];
            
            objectTimes[0] = {'day':'Sunday','o':data.openHour + ":" + data.openMins, 'c':data.closeHour + ":" + data.closeMins};
        }
         dayCount++;
       

        // -- Now Iteratre Through To Saturday
        while(from_date.add(1, 'days').diff(to_date) < 0) {
           
            let x = isHolidayDate( from_date, dayCount );
            if( !x ) {
                let data = openingTimes[  dayCount ];
                if( data ) {
                     objectTimes[ dayCount ] = {'day':days[dayCount],'o':data.openHour + ":" + data.openMins, 'c':data.closeHour + ":" + data.closeMins};
                }
            }

           dayCount++;

        }



    });
    

    function getOpeningTimesForWeekDay(weekDay) {
        return openingTimes.find(function(day) { 
            return day === weekDay
        });
    }

    function isHolidayDate( date, dayCount ) {

        if(!holiday) {
            return false;
        }

    
        var dateString = moment( date ).format("YYYY-MM-DD");


        let result = holiday.find(obj => {
           return obj.date === dateString
        })

   
        if( result ) {
            
            let chunks = result.hours.split(/:/);
          // console.log( result );
          //  console.log( chunks );
            openingTimes[dayCount].openHour = ("0" + chunks[0]).slice(-2);
            openingTimes[dayCount].openMins = (chunks[1] + "0").slice(-2);
            openingTimes[dayCount].closeHour = ("0" + chunks[2]).slice(-2);
            openingTimes[dayCount].closeMins = (chunks[3] + "0").slice(-2);


            
        }

   


        return false;
    }

</script>

<aside>
    <ul> 
    {#each objectTimes as time}
            <li>{time.day} - {time.o} - {time.c}</li>
    {/each}
    </ul>
</aside>